import { z } from 'zod';

export const SCHEDULING_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  ACTUALS_ONLY: 'ACTUALS_ONLY',
  PLANNED_AND_ACTUALS: 'PLANNED_AND_ACTUALS',
} as const;

export const schedulingTypeSchema = z.enum(SCHEDULING_TYPE);

export type SchedulingType = z.infer<typeof schedulingTypeSchema>;
